/* ───────────  CONSTANTS & UTILITIES  ─────────── */

export const UPLOAD_WORKER_URL = "https://image-service-uploader.t9e2i3kal.workers.dev";

export const cameraOptions = [
  "Staff Upload",
  "Gun Range", 
  "Car Crush",
  "Mud Pit",
  "Lobby",
  "Track",
  "Bunker",
];

export const generateUUID = () =>
  "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

export const getFileExtension = (name) =>
  name.includes(".") ? name.slice(name.lastIndexOf(".")) : "";

export const generateGuidFilename = (name) =>
  `${generateUUID()}${getFileExtension(name)}`;

export const isImage = (f) => f.type.startsWith("image/");
export const isVideo = (f) => f.type.startsWith("video/");
export const isMedia = (f) => isImage(f) || isVideo(f);

export const formatBytes = (b) => {
  if (!b) return "0 B";
  const i = ~~(Math.log2(b) / 10);
  return `${(b / 1024 ** i).toFixed(1)} ${["B", "KB", "MB", "GB"][i]}`;
};

/* ───────────  DATE UTILITIES  ─────────── */

export const getCurrentDateString = () => {
  const now = new Date();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const year = now.getFullYear();
  return `${month}/${day}/${year}`;
};

export const getYesterdayDateString = () => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const month = yesterday.getMonth() + 1;
  const day = yesterday.getDate();
  const year = yesterday.getFullYear();
  return `${month}/${day}/${year}`;
};

export const isDateTag = (tag) => {
  if (!tag || typeof tag !== 'string') return false;
  const dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  return dateRegex.test(tag);
};

export const getFriendlyDateLabel = (dateTag) => {
  if (!isDateTag(dateTag)) return dateTag;
  
  const now = new Date();
  const today = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
  
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayStr = `${yesterday.getMonth() + 1}/${yesterday.getDate()}/${yesterday.getFullYear()}`;
  
  if (dateTag === today) return "Today's Photos";
  if (dateTag === yesterdayStr) return "Yesterday's Photos";
  
  return dateTag;
};

export const isTodayDateTag = (tag) => {
  if (!isDateTag(tag)) return false;
  const now = new Date();
  const today = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
  return tag === today;
};

export const getDynamicCameraOptions = () => {
  const today = getCurrentDateString();
  const yesterday = getYesterdayDateString();
  
  return [
    ...cameraOptions,
    today,
    yesterday
  ];
};
